'use es6';

import { wrapReduxAction } from 'AdsUI/lib/ActionWrapper';
import ActionTypes from 'AdsUI/lib/Actions';
import * as LeadSyncingData from 'AdsUI/data/LeadSyncingData';
import { addHeaderBanner } from 'AdsUI/actions/BannerActions';
import BannerTypes from 'AdsUI/lib/BannerTypes';
export const fetchNotificationEmails = (network, leadSyncingEntityId, formId) => dispatch => {
  return wrapReduxAction(LeadSyncingData.fetchNotificationEmails.bind(LeadSyncingData, network, leadSyncingEntityId, formId), 'LEAD_AD_NOTIFICATION_EMAILS_FETCH', {
    dispatch,
    allParams: {
      network,
      id: formId
    },
    transform: response => ({
      response
    })
  });
};
export const updateNotificationEmails = (network, leadSyncingEntityId, formId, notificationEmails) => dispatch => {
  return wrapReduxAction(LeadSyncingData.updateNotificationEmails.bind(LeadSyncingData, network, leadSyncingEntityId, formId, notificationEmails), 'LEAD_AD_NOTIFICATION_EMAILS_UPDATE', {
    dispatch,
    success: () => {
      dispatch({
        type: ActionTypes.LEAD_AD_NOTIFICATION_EMAILS_UPDATE_SUCCEEDED,
        payload: {
          network,
          id: formId,
          notificationEmails
        }
      });
    },
    returnPromise: true
  });
};
export const fetchSelectedLeadSyncingEntities = () => dispatch => wrapReduxAction(LeadSyncingData.getSelectedLeadSyncingEntities.bind(LeadSyncingData), 'LEAD_SYNCING_SELECTED_FETCH', {
  dispatch
});
export const fetchErrorAlert = () => dispatch => wrapReduxAction(LeadSyncingData.getLeadSyncErrorAlert.bind(LeadSyncingData), 'LEAD_SYNCING_ERROR_ALERT_FETCH', {
  dispatch,
  success: response => {
    if (response.hasError) {
      dispatch(addHeaderBanner(BannerTypes.LEAD_SYNC_ERROR_ALERT, []));
    } else if (response.hasWarning) {
      dispatch(addHeaderBanner(BannerTypes.LEAD_SYNC_WARNING_ALERT, []));
    }
  }
});
export const deleteErrorAlert = () => dispatch => wrapReduxAction(LeadSyncingData.deleteLeadSyncErrorAlert.bind(LeadSyncingData), 'LEAD_SYNCING_ERROR_ALERT_DELETE', {
  dispatch
});